<template>
  <div class="app-container" ref="body">
    <div class="app-body">
      <van-nav-bar
        title="我的学籍"
        left-text="返回"
        left-arrow
        fixed
        class="fixedapp"
        @click-left="goBack('/')"
      />
      <van-pull-refresh
        v-model="isLoading"
        success-text="刷新成功"
        @refresh="onRefresh"
        style="min-height:calc(100vh - 50px);"
      >
        <van-cell-group title="个人信息">
          <van-cell is-link center :to="'/stu-info/'+ stu.id">
            <van-row>
              <!-- <van-col span="8">
                <van-image
                  width="90%"
                  :src="stu.pic ? rootPath + stu.pic : noimg"
                />
              </van-col> -->
              <van-col span="24">
                <div>
                  <p><span class="text-gray">姓　名：</span>{{ stu.name }}</p>
                  <p><span class="text-gray">性　别：</span>{{ stu.sexname }}</p>
                  <!-- <p>身份证：{{ stu.sfzh }}</p> -->
                  <p><span class="text-gray">手机号：</span>{{ stu.mobile }}</p>
                  <p><span class="text-gray">微信号：</span>{{ stu.weixin }}</p>
                </div>
              </van-col>
            </van-row>
          </van-cell>
        </van-cell-group>
        <van-cell-group title="学籍信息">
          <template v-for="item in stu.rollList">
            <van-cell :key="item.id" is-link center class="roll-item" :to="'/stu-roll/'+ item.id">
              <div>
                <p><van-tag :color="rollStatusColor(item.status)">{{ xjStatus[item.status] ? xjStatus[item.status].name : item.status }}</van-tag> {{ item.xjname }} / {{ item.ccname || '未定层次' }} </p>
                <p>{{ item.zyname || '未定专业' }} / {{ item.yxname || '未定院校' }}</p>
                <p>应缴费：<van-tag>{{ showPrice(item.total) }}</van-tag></p>
                <p>已缴费：<van-tag type="success">{{ showPrice(item.amount - item.reamount) }}</van-tag></p>
                <div class="d-flex mt-1">
                  <!-- <div v-if="!item.amount || item.amount <= 0" class="mr-1">
                    <van-button color="#7232dd" round plain icon="plus" @click.stop="addCyj(item)" style="white-space:nowrap;">缴纳预报名费</van-button>
                  </div> -->
                  <van-button type="info" round plain class="mr-1" @click.stop="goPay(item, 0)">缴费详情</van-button>
                  <van-button type="primary" round plain icon="plus" @click.stop="goPay(item, 1)" style="white-space:nowrap;">在线缴费</van-button>
                  <!-- <van-row>
                    <van-col span="10"></van-col>
                    <van-col v-if="(item.total - item.amount - item.reamount) > 0" offset="2" span="10"></van-col>
                  </van-row> -->
                </div>
              </div>
            </van-cell>
          </template>
        </van-cell-group>
      </van-pull-refresh>
    </div>
    <div class="signup-btns">
      <van-button round block type="warning" :loading="saveLoading" loading-text="加载中..." @click="unBindWeixin">
        解除绑定
      </van-button>
    </div>
    <FeeCyj :roll="roll" ref="cyj" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from 'jystore/mutation-types';
import siteMixin from '@/utils/site-mixin';
import FeeCyj from './stu-fee-cyj';
export default {
  components: {
    FeeCyj
  },
  mixins: [siteMixin],
  props: {
    id: String
  },
  data() {
    return {
      error: false,
      isLoading: false,
      stu: {},
      roll: {},
      saveLoading: false
    }
  },
  computed: {
    ...mapGetters({
      reloadWeb: [types.OTHER.reloadWeb],
      xjList: [types.BASE_LOAD.xjList],
      xjStatus: [types.BASE_LOAD.xjStatus]
    }),
    imageStyle() {
      let style = {};
      if (this.w) {
        style = {height: (this.w * 0.8) + 'px'};
      }
      return style;
    },
    imageStyle2() {
      let style = {}
      if (this.w) {
        let h = this.w * 0.618 * 0.26;
        style = {height: h + 'px'};
      }
      return style;
    },
    headerBg() {
      return {'background-image':'url('+ this.assetsPath +'static/images/header-bg.png)'};
    },
    meTitle() {
      return this.stuList.length > 1 ? '我的学生' : '我的学籍';
    }
  },
  watch: {
    reloadWeb() {
      this.loadData();
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData(callback) {
      if (!this.xjList || !this.xjList.length) {
        this.$store.dispatch(types.BASE_LOAD.xjList);
      }
      if (!this.xjStatus || !Object.keys(this.xjStatus).length) {
        this.$store.dispatch(types.BASE_LOAD.xjStatus);
      }
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.doPost({
        url: 'site/home/getStu/'+ this.id,
        data: {},
        okcb: (json) => {
          if (callback && callback instanceof Function) {
            callback(json);
          } else {
            this.setData(json);
          }
        },
        cb: () => {
          this.$nextTick(() => this.isLoading = false);
        },
        errcb: () => {
          this.error = true;
        }
      });
    },
    setData(json) {
      this.stu = Object.assign({}, json);
    },
    onRefresh() {
      this.isLoading = false;
      this.loadData((json) => {
        this.setData(json);
        this.$toast('刷新成功');
      });
    },
    addPay(data) {
      this.$router.push('/stu-fee/'+ data.id);
    },
    goPay(data, t) {
      this.$router.push({name:'site-stufee', params: {id: data.id, action: t ? 'pay' : ''} });
    },
    addCyj(data) {
      this.roll = data;
      this.$refs.cyj.show(1);
    },
    unBindWeixin() {
      this.Dialog.confirm({
        message: '确定要解除绑定该学生吗？'
      }).then(() => {
        this.saveLoading = true;
        this.doPost({
          url: 'site/bind/unbind',
          data: {
            id: this.id
          },
          okcb: () => {
            this.Toast('解绑成功！');
            this.$store.commit(types.OTHER.reloadWeb);
            this.$router.replace('/');
          },
          cb: () => {
            this.saveLoading = false;
          }
        })
      }).catch(() => {
        this.Toast('取消解绑！');
      });
    }
  }
}
</script>
<style lang="less" scoped>
.app-body {
  padding-top:46px;
  padding-bottom:10px;
  min-height:calc(100vh - 56px);
  background-color:#f5f5f5;
}
.roll-item{
  padding:1rem;
  background-color:#fff;
}
.roll-item::before {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 2px;
  background: -webkit-repeating-linear-gradient(135deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #1989fa 0, #1989fa 45%, transparent 0, transparent 50%);
  background: repeating-linear-gradient(-45deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #1989fa 0, #1989fa 45%, transparent 0, transparent 50%);
  background-size: 80px;
  content: '';
}
.signup-btns {
  position:fixed;
  left: 50%;
  bottom: 1rem;
  width: 100%;
  max-width: 750px;
  .flex-center-v();
  transform: translateX(-50%);
  /deep/ .van-button--normal {
    .fontsize(1.2rem);
  }
  .prices {
    margin-right:2rem;
    padding:.5rem 1rem;
    white-space: nowrap;
    flex-shrink: 0;
    background-color:#f0f0f0;
    border-radius:2rem;
    .price {
      display: inline-block;
      color: #ff6600;
      .fontsize(1.2rem);
      small {
        .fontsize(.85rem);
      }
    }
  }
}
</style>